<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn
                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>
        <v-container fluid>
            <v-card
                    class="pa-4"
                    flat
            >
                <v-toolbar
                        dense
                >
                    <v-col cols="12" sm="4" md="3">
                        <v-menu


                                v-model="start_date"
                                :close-on-content-click="false"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        style="padding-top:45px;"
                                        v-model="search.start_date"
                                        label="Start Date"
                                        prepend-icon="mdi-event"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="search.start_date"
                                           @input="start_date = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="4" md="3">
                        <v-menu
                                v-model="end_date"
                                :close-on-content-click="false"

                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        style="padding-top:45px;"
                                        v-model="search.end_date"
                                        label="End Date"
                                        prepend-icon="mdi-event"
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="search.end_date" @input="end_date = false"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                                hide-details
                                single-line
                                label="Customer Name Filter"
                                v-model="search.customer"
                        ></v-text-field>
                    </v-col>
                    <v-btn
                            @click="filter_results(search)"
                            icon
                            color="blue-grey darken-4">
                        <v-icon>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
        </v-container>

        <v-container fluid>
            <v-card color="basil">
                <v-card-title class="text-center justify-center py-6">
                    <h1 class="font-weight-bold display-3 basil--text">
                        REPORTS
                    </h1>
                </v-card-title>

                <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="basil"
                        @click="load_filter_orders(tab)"
                        grow
                >
                    <v-tab
                            v-for="(tab, index) in tab_data"
                            :key="index"
                    >
                        {{ tab.name }}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item
                            v-for="(tab, index) in tab_data"
                            :key="index"
                    >
                        <v-card flat color="basil">
                            <v-card-text>
                                <div v-show="tab.id === 1">
                                    <h3>
                                        Daily Report
                                    </h3>
                                    <small>
                                        {{ tab.date }}
                                    </small>
                                    <v-simple-table class="text-center">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-center">Customer</th>
                                                <th class="text-center">Time</th>
                                                <th class="text-center">Product</th>
                                                <th class="text-center">Price</th>
                                                <th class="text-center">Server</th>
                                                <th>
                                                    Cash
                                                </th>
                                                <th>
                                                    Alipay
                                                </th>
                                                <th>
                                                    Card
                                                </th>
                                                <th>
                                                    Wechat
                                                </th>
                                                <th>
                                                    Discounts
                                                </th>
                                                <th>
                                                    Credit
                                                </th>
                                                <th>
                                                    Tab
                                                </th>
                                                <th>
                                                    Total Sales
                                                </th>
                                                <th>
                                                    Net Sales
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in tab.orders" :key="index">
                                                <td v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                   <span v-if="item.customer">
                                                        {{ item.customer.name }}
                                                   </span>
                                                </td>
                                                <td v-bind:class="{'blue-grey lighten-4':item.is_last_order }">

                                                    <span v-show="item.state !== 2">
                                                        {{ item.time }}
                                                    </span>
                                                    <span v-show="item.state === 2">
                                                        {{ formatDateDownload(item.created_at) }} {{ item.time }}
                                                    </span>
                                                </td>
                                                <td v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    {{ item.product_name }}
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    {{ item.price }}
                                                </td>
                                                <td v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-if="item.staff">
                                                        {{ item.staff.name }}
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order === true">
                                                        {{ item.cash }}
                                                    </span>
                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.alipay }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.card }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.wechat }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.discount }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.credit }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="text-center"
                                                    v-bind:class="{'blue-grey lighten-4':item.is_last_order }">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.tab }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="blue-grey lighten-4 text-center">
                                                    <span v-show="item.is_last_order">
                                                        {{ item.total_sales }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                                <td class="blue-grey lighten-4 text-center">
                                                    <span v-show="item.is_last_order === true">
                                                        {{ item.total_net_sales }}
                                                    </span>

                                                    <span v-show="!item.is_last_order">
                                                        -
                                                    </span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </div>
                                <div v-show="tab.id === 2">
                                    <h3>
                                        Rolling Month Report
                                    </h3>
                                    <small>
                                        {{ tab.date }}
                                    </small>
                                    <v-simple-table class="text-center">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-center">Date</th>
                                                <th class="text-center">Day</th>
                                                <th class="text-center">Total Sales</th>
                                                <th class="text-center">Discount</th>
                                                <th class="text-center">Tabs</th>
                                                <th class="text-center">Credit</th>
                                                <th class="text-center">Net Sales</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in tab.orders" :key="index">
                                                <td>
                                                    {{ item.date }}
                                                </td>
                                                <td>
                                                    {{ item.day }}
                                                </td>
                                                <td>
                                                    {{ item.total_sales }}
                                                </td>
                                                <td>
                                                    {{ item.discount }}
                                                </td>
                                                <td>
                                                    {{ item.tabs }}
                                                </td>
                                                <td>
                                                    {{ item.credit }}
                                                </td>
                                                <td>
                                                    {{ item.net_sales }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </div>
                                <div v-show="tab.id === 3">
                                    <h3>
                                        Monthly Report
                                    </h3>
                                    <small>
                                        {{ tab.date }}
                                    </small>
                                    <v-simple-table class="text-center">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-center">Customer</th>
                                                <th class="text-center">Days Visited</th>
                                                <th class="text-center">
                                                    Bills
                                                </th>
                                                <th class="text-center">
                                                    Cash
                                                </th>
                                                <th class="text-center">
                                                    Alipay
                                                </th>
                                                <th>
                                                    Card
                                                </th>
                                                <th>
                                                    Wechat
                                                </th>
                                                <th>
                                                    Discounts
                                                </th>
                                                <th>
                                                    Tab
                                                </th>
                                                <th>
                                                    Credit
                                                </th>
                                                <th>
                                                    Total Sales
                                                </th>
                                                <th>
                                                    Net Sales
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in tab.orders" :key="index">
                                                <td>
                                                    {{ item.customer }}
                                                </td>
                                                <td>
                                                    {{ item.days_visited }}
                                                </td>
                                                <td>
                                                    {{ item.bills }}
                                                </td>
                                                <td>
                                                    {{ item.cash }}
                                                </td>
                                                <td>
                                                    {{ item.alipay }}
                                                </td>
                                                <td>
                                                    {{ item.card }}
                                                </td>
                                                <td>
                                                    {{ item.wechat }}
                                                </td>
                                                <td>
                                                    {{ item.discount }}
                                                </td>
                                                <td>
                                                    {{ item.tab }}
                                                </td>
                                                <td>
                                                    {{ item.credit }}
                                                </td>
                                                <td>
                                                    {{ item.total_sales }}
                                                </td>
                                                <td>
                                                    {{ item.net_sales - item.tab }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </div>
                                <div v-show="tab.id === 4">
                                    <h3>
                                        Current Outstanding Tabs
                                    </h3>
                                    <small>
                                        {{ tab.date }}
                                    </small>
                                    <v-simple-table class="text-center">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-center">Customer</th>
                                                <th class="text-center">Date</th>
                                                <th class="text-center">
                                                    Value
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="item in tab.orders">
                                                <td>
                                                    {{ item.customer }}
                                                </td>
                                                <td>
                                                    {{ item.date }}
                                                </td>
                                                <td>
                                                    {{ item.value }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <h3 class="mt-2 mb-2">
                                        Current Credits
                                    </h3>
                                    <v-simple-table class="text-center">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-center">Customer</th>
                                                <th class="text-center">Exp Date</th>
                                                <th class="text-center">
                                                    Value
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="item in credits">
                                                <td>
                                                    {{ item.customer_item.name }}
                                                </td>
                                                <td>
                                                    {{ formatDateDownload(item.expire_on) }}
                                                </td>
                                                <td>
                                                    {{ item.credit }}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </div>
                                <div v-show="tab.id === 5">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Drink</th>
                                                <th class="text-left">QTY</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in tab.orders" :key="index">
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.qty }}</td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </div>
                            </v-card-text>

                        </v-card>

                        <v-card v-show="tab.id === 1" flat color="basil">
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="4" md="3">
                                            <h3 class="subtitle-1">
                                                Daily Summary
                                            </h3>
                                            <table class="text-left">
                                                <tr>
                                                    <th class="pr-5">
                                                        Total Sales


                                                    </th>
                                                    <th>
                                                        {{ totals.amounts.sales }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        Tabs
                                                    </th>
                                                    <th>
                                                        {{ totals.amounts.tabs }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        Discounts
                                                    </th>
                                                    <th>
                                                        {{ totals.amounts.discounts }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        Credits
                                                    </th>
                                                    <th>
                                                        {{ totals.amounts.credit }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        Net Sales
                                                    </th>
                                                    <th>
                                                        {{ totals.amounts.net_sales }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="3">
                                            <table class="text-left">
                                                <tr>
                                                    <th class="pr-5">Total Customers</th>
                                                    <th>
                                                        {{ totals.counts.customers }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>Total Orders</th>
                                                    <th>
                                                        {{ totals.counts.orders }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>Total Discounts</th>
                                                    <th>
                                                        {{ totals.counts.discounts }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                            <h3 class="subtitle-1">
                                                Payment Types
                                            </h3>
                                            <table class="text-left">
                                                <tr>
                                                    <th class="pr-12">Cash</th>
                                                    <th>
                                                        {{ totals.amounts.cash }}

                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>Alipay</th>
                                                    <th>
                                                        {{ totals.amounts.alipay }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>Card</th>
                                                    <th>
                                                        {{ totals.amounts.card }}

                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th>Wechat</th>
                                                    <th>
                                                        {{ totals.amounts.wechat }}
                                                    </th>
                                                </tr>
                                            </table>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <v-card class="pa-6">
                            <v-btn
                                    block
                                    outlined
                                  color="blue-grey darken-4"
                                  @click="download_orders(tab, totals)"
                                >x
                                  Download
                                </v-btn>
                        </v-card>

                    </v-tab-item>
                </v-tabs-items>
            </v-card>

        </v-container>

    </div>
</template>


<script>
    import moment from 'moment'
    import Excel from 'exceljs'
    import { saveAs } from 'file-saver'

    export default {
        components: {Excel, saveAs},
        data() {
            return {
                credits:[],
                tab: null,
                notification: false,
                notification_type: '',
                notification_message: '',
                tab_data: [],
                totals: {
                    amounts: {
                        sales: 0,
                        tabs: 0,
                        discounts: 0,
                        net_sales: 0,
                        cash: 0,
                        alipay: 0,
                        card: 0,
                        wechat: 0,
                        credit:0,
                    },
                    counts: {
                        customers: 0,
                        orders: 0,
                        discounts: 0,
                        credit: 0,
                    }
                },
                start_date: false,
                end_date: false,
                search: {},
                tabs: [],
                filter_month: ''
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            tab(val) {
                let tab = this.tab_data[val];
                console.log(tab);
                this.load_filter_orders(tab);
            }
        },
        created() {
            let TodayDate = new Date();
            let d = TodayDate.getDate();
            let m = TodayDate.getMonth() + 1;
            let y = TodayDate.getFullYear();
            let from_date = new Date(moment(TodayDate).subtract(1, 'day'));
            let to_date = new Date(moment(TodayDate));
            let filter_from_date = from_date.getFullYear() + '-' + (from_date.getMonth() + 1) + '-' + from_date.getDate();
            let filter_to_date = to_date.getFullYear() + '-' + (to_date.getMonth() + 1) + '-' + to_date.getDate();
            let filter_month = from_date.getFullYear() + '-' + (from_date.getMonth() + 1) + '-01';
            this.filter_month = filter_month;
            this.tab_data = [
                {
                    id: 1,
                    name: 'Daily Report',
                    filter: '&start_date=' + filter_from_date + ' 10:30:00' + '&end_date=' + filter_to_date + ' 10:30:00' + '&states=2,3',
                    date: new Date()
                },
                {
                    id: 5,
                    name: 'Drinks Daily',
                    filter: '&def_start_created_at=' + filter_from_date + ' 10:30:00' + '&def_end_created_at=' + filter_to_date + ' 10:30:00' + '&states=2,3',
                    date: new Date()
                },
                {
                    id: 2,
                    name: 'Rolling Monthly',
                    filter: '&exact_date='+filter_month+'&states=2,3'
                },
                {
                    id: 3,
                    name: 'Monthly Report',
                    filter: '&start_date=' + y + '-'+m+'-01&states=3'
                },
                {
                    id: 4,
                    name: 'Outstanding Tabs',
                    filter: '&state=2'
                }
            ];

            this.load_filter_orders(this.tab_data[0]);
        },
        methods: {
            async download_orders(tab, totals)
            {
                let self = this;

                try {
                    let workbook = new Excel.Workbook();
                    workbook.creator = 'BNC ORDER SYS';
                    workbook.lastModifiedBy = 'Martyn';
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    let bnc_work_name = 'BNC - ';

                    workbook.views = [
                        {
                            x: 0, y: 0, width: 10000, height: 20000,
                            firstSheet: 0, activeTab: 1, visibility: 'visible'
                        }
                    ];
                    let sheet = workbook.addWorksheet('BNC ORDER', {
                        pageSetup:{paperSize: 9, orientation:'landscape'}
                    });
                    // Set Print Area for a sheet
                    sheet.pageSetup.printArea = 'A1:G20';

                    // Repeat specific rows on every printed page
                    sheet.pageSetup.printTitlesRow = '1:1';

                    // Repeat specific columns on every printed page
                    sheet.pageSetup.printTitlesColumn = 'A:C';

                    // sheet.getColumn('B').width = 30;
                    let letters = 'ABCDEFGHIJKLMNOPQR'.split('');
                    let grey = 'f5f5f5';
                    let blue  = 'cbdeef';
                    let headers = [];
                    let drinks = [];
                    let i =0;
                    switch (tab.id) {
                        case 1:
                            bnc_work_name += 'DAILY';
                            headers = [
                                'Customer',
                                'Time',
                                'Product',
                                'Price',
                                'Server',
                                'Cash',
                                'Alipay',
                                'Card',
                                'Wechat',
                                'Discounts',
                                'Credit',
                                'Tab',
                                'Total Sales',
                                'Net Sales'
                            ];
                            i=0;
                            headers.forEach(function(header){
                                sheet.getCell(letters[i]+'1').value = header;
                                sheet.getCell(letters[i]+'1').border = {
                                    top: {style:'thick'},
                                    left: {style:'thick'},
                                    bottom: {style:'thick'},
                                    right: {style:'thick'}
                                };
                                sheet.getCell(letters[i]+'1').font = {
                                    size: 14,
                                    italic: true,
                                    bold:true
                                };
                                i++;
                            });
                            let row = 2;
                            tab.orders.forEach(function(o){
                                // alipay: 0
                                // card: 0
                                // cash: 150
                                // customer: {name: "Total"}
                                // discount: 0
                                // is_last_order: true
                                // price: 150
                                // product_name: ""
                                // staff: {name: "Taishan"}
                                // tab: 0
                                // time: ""
                                // total_net_sales: 150
                                // total_sales: 150
                                // wechat: 0

                                if(typeof o.alipay === 'undefined')
                                {
                                    o.alipay = '-';
                                }
                                if(typeof o.wechat === 'undefined')
                                {
                                    o.wechat = '-';
                                }
                                if(typeof o.cash === 'undefined')
                                {
                                    o.cash = '-';
                                }
                                if(typeof o.card === 'undefined')
                                {
                                    o.card = '-';
                                }
                                if(typeof o.discount === 'undefined')
                                {
                                    o.discount = '-';
                                }
                                if(typeof o.credit === 'undefined')
                                {
                                    o.credit = '-';
                                }
                                if(typeof o.total_sales === 'undefined')
                                {
                                    o.total_sales = '-';
                                }
                                if(typeof o.total_net_sales === 'undefined')
                                {
                                    o.total_net_sales = '-';
                                }
                                if(typeof o.tab === 'undefined')
                                {
                                    o.tab = '-';
                                } else {
                                    i=0;
                                    headers.forEach(function(header){
                                        sheet.getCell(letters[i]+row).value = header;
                                        sheet.getCell(letters[i]+row).fill = {
                                            type: 'pattern',
                                            pattern:'solid',
                                            fgColor:{
                                                argb: grey
                                            }
                                        };
                                        sheet.getCell(letters[i]+row).border = {
                                            top: {style:'thick'},
                                            left: {style:'thick'},
                                            bottom: {style:'thick'},
                                            right: {style:'thick'}
                                        };
                                        sheet.getCell(letters[i]+row).font = {
                                            bold:true
                                        };
                                        i++;
                                    });


                                }
                                sheet.getCell('A'+row).value = o.customer.name;
                                sheet.getCell('B'+row).value = o.time;
                                if(o.state === 2)
                                {
                                    sheet.getCell('B'+row).value = self.formatDateDownload(o.created_at) + ' :-: ' + o.time;
                                } else {
                                    sheet.getCell('B'+row).value = o.time;
                                }
                                sheet.getCell('C'+row).value = o.product_name;
                                sheet.getCell('D'+row).value = o.price;
                                sheet.getCell('E'+row).value = o.staff.name;
                                sheet.getCell('F'+row).value = o.cash;
                                sheet.getCell('G'+row).value = o.alipay;
                                sheet.getCell('H'+row).value = o.card;
                                sheet.getCell('I'+row).value = o.wechat;
                                sheet.getCell('J'+row).value = o.discount;
                                sheet.getCell('K'+row).value = o.credit;
                                sheet.getCell('L'+row).value = o.tab;
                                sheet.getCell('M'+row).value = o.total_sales;
                                sheet.getCell('N'+row).value = o.total_net_sales;



                                row++;
                            });

                            row += 5;
                            sheet.getCell('B'+row).value = 'Daily Summary';
                            sheet.getCell('D'+row).value = 'Total Customers';
                            sheet.getCell('E'+row).value = totals.counts.customers;
                            row++;
                            sheet.getCell('B'+row).value = 'Total Sales';
                            sheet.getCell('C'+row).value = totals.amounts.sales;
                            sheet.getCell('D'+row).value = 'Total Orders';
                            sheet.getCell('E'+row).value = totals.counts.orders;
                            row++;
                            sheet.getCell('B'+row).value = 'Tabs';
                            sheet.getCell('C'+row).value = totals.amounts.tabs;
                            sheet.getCell('D'+row).value = 'Total Discounts';
                            sheet.getCell('E'+row).value = totals.counts.discounts;
                            row++;
                            sheet.getCell('B'+row).value = 'Discounts';
                            sheet.getCell('C'+row).value = totals.amounts.discounts;
                            row++;
                            sheet.getCell('B'+row).value = 'Credit';
                            sheet.getCell('C'+row).value = totals.amounts.credit;
                            row++;
                            sheet.getCell('B'+row).value = 'Net Sales';
                            sheet.getCell('C'+row).value = totals.amounts.net_sales;

                            row += 2;
                            sheet.getCell('B'+row).value = 'Payment Types';
                            row++;
                            sheet.getCell('B'+row).value = 'Cash';
                            sheet.getCell('C'+row).value = totals.amounts.cash;
                            row++;
                            sheet.getCell('B'+row).value = 'Alipay';
                            sheet.getCell('C'+row).value = totals.amounts.alipay;
                            row++;
                            sheet.getCell('B'+row).value = 'Card';
                            sheet.getCell('C'+row).value = totals.amounts.card;
                            row++;
                            sheet.getCell('B'+row).value = 'Wechat';
                            sheet.getCell('C'+row).value = totals.amounts.wechat;

                        // amounts: Object
                        //     alipay: 815
                        //     card: 320
                        //     cash: 860
                        //     discounts: 75
                        //     net_sales: 6395
                        //     sales: 6550
                        //     tabs: 80
                        //     wechat: 4400
                        //
                        // counts: Object
                        //     customers: 31
                        //     discounts: 1
                        //     orders: 183
                            break;
                        case 2:
                            bnc_work_name += 'Rolling Monthly';
                            headers = [
                                'Date',
                                'Day',
                                'Total Sales',
                                'Total Tabs',
                                'Total Discounts',
                                'Net Sales'
                            ];
                            i=0;
                            row=1;
                            headers.forEach(function(header){
                                sheet.getCell(letters[i]+row).value = header;
                                sheet.getCell(letters[i]+row).border = {
                                    top: {style:'thick'},
                                    left: {style:'thick'},
                                    bottom: {style:'thick'},
                                    right: {style:'thick'}
                                };
                                sheet.getCell(letters[i]+row).font = {
                                    size: 14,
                                    italic: true,
                                    bold:true
                                };
                                i++;
                            });
                            row++;
                            tab.orders.forEach(function(order){
                                sheet.getCell('A'+row).value = order.date;
                                sheet.getCell('B'+row).value = order.day;
                                sheet.getCell('C'+row).value = order.total_sales;
                                sheet.getCell('D'+row).value = order.tabs;
                                sheet.getCell('E'+row).value = order.discount;
                                sheet.getCell('F'+row).value = order.net_sales;
                                row++;
                            });
                            break;
                        case 3:
                            bnc_work_name += 'Monthly';
                            headers = [
                                'Customer',
                                'Days Visited',
                                'Bills',
                                'Cash',
                                'Alipay',
                                'Card',
                                'Wechat',
                                'Discounts',
                                'Tab',
                                'Total Sales',
                                'Total Net',
                            ];

                            row =1;
                            i=0;

                            headers.forEach(function(header){
                                sheet.getCell(letters[i]+row).value = header;
                                sheet.getCell(letters[i]+row).border = {
                                    top: {style:'thick'},
                                    left: {style:'thick'},
                                    bottom: {style:'thick'},
                                    right: {style:'thick'}
                                };
                                sheet.getCell(letters[i]+row).font = {
                                    size: 14,
                                    italic: true,
                                    bold:true
                                };
                                i++;
                            });
                            row++;
                            i=0;

                            tab.orders.forEach(function(order){
                                sheet.getCell('A'+row).value = order.customer;
                                sheet.getCell('B'+row).value = order.days_visited;
                                sheet.getCell('C'+row).value = order.bills;
                                sheet.getCell('D'+row).value = order.cash;
                                sheet.getCell('E'+row).value = order.alipay;
                                sheet.getCell('F'+row).value = order.card;
                                sheet.getCell('G'+row).value = order.wechat;
                                sheet.getCell('H'+row).value = order.discount;
                                sheet.getCell('I'+row).value = order.tab;
                                sheet.getCell('J'+row).value = order.total_sales;
                                sheet.getCell('K'+row).value = order.net_sales;
                                row++;
                            });
                            break;
                        case 4:
                            bnc_work_name += 'Tabs';
                            console.log(tab.orders);

                            row =1;
                            i=0;

                            headers = [
                                'Customer',
                                'Date',
                                'Value',
                            ];
                            headers.forEach(function(header){
                                sheet.getCell(letters[i]+row).value = header;
                                sheet.getCell(letters[i]+row).border = {
                                    top: {style:'thick'},
                                    left: {style:'thick'},
                                    bottom: {style:'thick'},
                                    right: {style:'thick'}
                                };
                                sheet.getCell(letters[i]+row).font = {
                                    size: 14,
                                    italic: true,
                                    bold:true
                                };
                                i++;
                            });
                            row++;
                            i=0;

                            tab.orders.forEach(function(order){
                                sheet.getCell('A'+row).value = order.customer;
                                sheet.getCell('B'+row).value = order.date;
                                sheet.getCell('C'+row).value = order.value;
                                row++;
                            });
                            break;
                        case 5:
                            headers = [
                                'Product',
                                'QTY'
                            ];
                            bnc_work_name += 'DAILY DRINKS QTY';
                            row = 1;
                            sheet.getCell('A'+row).value = 'Product';
                            sheet.getCell('B'+row).value = 'QTY';
                            headers.forEach(function(header){
                                sheet.getCell(letters[i]+row).value = header;
                                sheet.getCell(letters[i]+row).border = {
                                    top: {style:'thick'},
                                    left: {style:'thick'},
                                    bottom: {style:'thick'},
                                    right: {style:'thick'}
                                };
                                sheet.getCell(letters[i]+row).font = {
                                    size: 14,
                                    italic: true,
                                    bold:true
                                };
                                i++;
                            });
                            row++;
                            i=0;
                            drinks = tab.orders;

                            drinks.sort((a, b) => parseInt(a.qty) - parseInt(b.qty));

                            drinks.forEach(function(drink){
                                sheet.getCell('A'+row).value = drink.name;
                                sheet.getCell('B'+row).value = drink.qty;
                                row++
                            });
                            break;
                    }






                    let buffer = await workbook.xlsx.writeBuffer();

                    saveAs(new Blob([buffer]), bnc_work_name+".xlsx");
                } catch(e){
                    console.log(e)
                }
            },
            load_filter_orders(tab) {
                console.log('TAB '+tab.id);
                console.log(tab);
                let search_url = '';

                if (tab.id !== 3 && tab.id !== 2) {
                    search_url = '/admin/order-lines/';
                } else {
                    search_url = '/admin/orders/';
                }
                console.log(search_url);
                search_url += '?limit=100000' + tab.filter;

                console.log(search_url);
                this.$http.get(
                    this.$http.defaults.baseURL + search_url).then((response) => {
                    switch (tab.id) {
                        case 1:
                            this.build_daily_sales(response, tab);
                            break;
                        case 2:
                            this.build_rolling_monthly(response, tab);
                            break;
                        case 3:
                            this.build_monthly(response, tab);
                            break;
                        case 4:
                            this.build_outstanding_tabs(response, tab);
                            break;
                        case 5:
                            this.build_drinks(response, tab);
                            break;
                    }


                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });

            },
            build_drinks(response, tab) {
                let drinks = [];
                tab.orders = [];
                console.log(response);
                response.data.forEach(function (o, i) {
                    let name = o.product.category.name + ' ' + o.product.name;
                    let qty = 1;
                    let existing = drinks.find(o => o.name === name);
                    if(typeof existing === 'undefined')
                    {
                        drinks.push({
                            name: name,
                            qty:qty
                        })
                    } else {
                        existing.qty += 1
                    }
                });
                tab.orders = drinks;
                this.$forceUpdate();
            },
            build_daily_sales(response, tab) {
                let self = this;
                tab.orders = [];

                let last_customer = '';
                let last_order = {};
                let final_push = {};
                let count = 0;

                /**
                 * TOTALS FOR EACH CUSTOMER
                 */
                let totals = {
                    amounts: {
                        sales: 0,
                        tabs: 0,
                        discounts: 0,
                        net_sales: 0,
                        cash: 0,
                        alipay: 0,
                        card: 0,
                        wechat: 0,
                        credit: 0,
                    },
                    counts: {
                        customers: 0,
                        orders: 0,
                        discounts: 0,
                        credit: 0
                    }
                };
                /**
                 * TOTALS FOR ALL CUSTOMERS
                 */
                let final_totals = {
                    amounts: {
                        sales: 0,
                        tabs: 0,
                        discounts: 0,
                        net_sales: 0,
                        cash: 0,
                        alipay: 0,
                        card: 0,
                        wechat: 0,
                        credit: 0,
                    },
                    counts: {
                        customers: 0,
                        orders: 0,
                        discounts: 0,
                        credit: 0
                    }
                };
                response.data.forEach(function (o, i) {
                    o.is_last_order = false;
                    final_totals.counts.orders++;
                    let server = '';
                    // set the default last order customer
                    if (last_customer === '') {
                        last_customer = o.customer.name;
                    }
                    // if last order set details clear totals for next customer
                    if (last_customer !== o.customer.name || last_order.invoice_id !== o.invoice_id) {
                       if(count !== 0)
                       {
                           final_totals.counts.customers++;

                           if (last_order.order) {
                               if (typeof last_order.order.server !== 'undefined') {
                                   server = last_order.order.server.name
                               }
                           }
                           let time = '';
                           if(typeof last_order.order.created_at !== undefined && last_order.order.created_at)
                           {
                               time = self.formatTimeDownload(last_order.order.created_at);
                           }
                           final_push = {
                               customer: {
                                   name: 'Total'
                               },
                               is_last_order: true,
                               time: time,
                               staff: {
                                   name: server
                               },
                               product_name: '',
                               price: totals.amounts.sales,
                               cash: totals.amounts.cash,
                               alipay: totals.amounts.alipay,
                               card: totals.amounts.card,
                               wechat: totals.amounts.wechat,
                               credit: totals.amounts.credit,
                               discount: totals.amounts.discounts,
                               tab: totals.amounts.tabs,
                               total_sales: totals.amounts.sales,
                               total_net_sales: totals.amounts.sales - (totals.amounts.discounts + totals.amounts.tabs)
                           };
                           console.log(totals);
                           //clear totals before next customer data
                           totals = {
                               amounts: {
                                   sales: 0,
                                   tabs: 0,
                                   discounts: 0,
                                   discount: 0,
                                   net_sales: 0,
                                   cash: 0,
                                   alipay: 0,
                                   card: 0,
                                   wechat: 0,
                                   credit: 0,
                               },
                               counts: {
                                   customers: 0,
                                   orders: 0,
                                   discounts: 0,
                                   credit: 0,
                               }
                           };
                           tab.orders.push(final_push);
                       }
                    }
                    o.date = self.formatDateDownload(o.created_at);
                    o.time = self.formatTimeDownload(o.created_at);

                    if (o.state === 2) {
                        o.cash = 0;
                        o.alipday = 0;
                        o.discount = 0;
                        o.wechat = 0;
                        o.tab = o.price;
                    } else {
                        if (last_order.invoice_id !== o.invoice_id) {
                            o.order.payment_types.forEach(function (n, m) {
                                switch (n.type) {
                                    case 1://cash
                                        totals.amounts.cash += n.amount;
                                        final_totals.amounts.cash += n.amount;

                                        totals.amounts.net_sales += n.amount;
                                        totals.amounts.sales += n.amount;
                                        final_totals.amounts.sales += n.amount;
                                        final_totals.amounts.net_sales += n.amount;
                                        break;
                                    case 2://wechat
                                        totals.amounts.wechat += n.amount;
                                        final_totals.amounts.wechat += n.amount;

                                        totals.amounts.net_sales += n.amount;
                                        totals.amounts.sales += n.amount;
                                        final_totals.amounts.sales += n.amount;
                                        final_totals.amounts.net_sales += n.amount;

                                        break;
                                    case 3://alipay
                                        totals.amounts.alipay += n.amount;
                                        final_totals.amounts.alipay += n.amount;


                                        totals.amounts.net_sales += n.amount;
                                        totals.amounts.sales += n.amount;
                                        final_totals.amounts.sales += n.amount;
                                        final_totals.amounts.net_sales += n.amount;
                                        break;
                                    case 4://card
                                        totals.amounts.card += n.amount;
                                        final_totals.amounts.card += n.amount;

                                        totals.amounts.net_sales += n.amount;
                                        totals.amounts.sales += n.amount;
                                        final_totals.amounts.sales += n.amount;
                                        final_totals.amounts.net_sales += n.amount;
                                        break;
                                    case 5://manager discount
                                        if (n.amount > 0) {
                                            final_totals.counts.discounts++;
                                        }
                                        final_totals.amounts.discounts += n.amount;
                                        final_totals.amounts.sales += n.amount;
                                        // final_totals.amounts.net_sales -= n.amount;
                                        totals.amounts.discounts += n.amount;
                                        totals.amounts.sales += n.amount;
                                        totals.amounts.net_sales -= n.amount;
                                        break;
                                    case 7://credit
                                        if (n.amount > 0) {
                                            final_totals.counts.credit++;
                                        }
                                        final_totals.amounts.credit += n.amount;
                                        final_totals.amounts.sales += n.amount;
                                        // final_totals.amounts.net_sales -= n.amount;
                                        totals.amounts.credit += n.amount;
                                        totals.amounts.sales += n.amount;
                                        totals.amounts.net_sales -= n.amount;
                                        break;

                                }
                            });
                        }
                    }
                    o.product_name = o.product.category.name + ' ' + o.product.name;

                    tab.orders.push(o);
                    last_order = o;
                    count++;
                    last_customer = o.customer.name;
                    if (o.state === 2) {

                        totals.amounts.tabs += o.price;
                        totals.amounts.sales += o.price;
                        // totals.amounts.net_sales -= o.price;

                        final_totals.amounts.tabs += o.price;
                        final_totals.amounts.sales += o.price;
                    }

                    if (count === response.data.length) {
                        if (o.order) {
                            if (typeof o.order.server !== 'undefined') {
                                server = o.order.server.name
                            }
                        }
                        final_totals.counts.customers++;
                        final_push = {
                            customer: {
                                name: 'Total'
                            },
                            is_last_order: true,
                            time: '',
                            staff: {
                                name: server
                            },
                            product_name: '',
                            price: totals.amounts.sales,
                            cash: totals.amounts.cash,
                            alipay: totals.amounts.alipay,
                            card: totals.amounts.card,
                            wechat: totals.amounts.wechat,
                            credit: totals.amounts.credit,
                            discount: totals.amounts.discounts,
                            tab: totals.amounts.tabs,
                            total_sales: totals.amounts.sales,
                            total_net_sales: totals.amounts.net_sales
                        };
                        tab.orders.push(final_push);
                    }

                });
                this.totals = final_totals;
                this.$forceUpdate();
            },
            build_monthly(response, tab) {
                this.load_tabs().then(tabs => {

                    let orders = [];
                    let cash = 0;
                    let wechat = 0;
                    let alipay = 0;
                    let card = 0;
                    let discount = 0;
                    let credit = 0;
                    let totals = {
                        cash: 0,
                        card: 0,
                        bills: 0,
                        alipay: 0,
                        wechat: 0,
                        discount: 0,
                        credit: 0,
                        tab: 0,
                        sales: 0,
                        net_sales: 0,
                    };
                    let self = this;
                    response.data.forEach(function (o, i) {
                        let existing = orders.find(n => n.customer === o.customer.name);

                        cash = 0;
                        wechat = 0;
                        alipay = 0;
                        card = 0;
                        discount = 0;
                        credit = 0;

                        o.payment_types.forEach(function (n, m) {
                            switch (n.type) {
                                case 1://cash
                                    cash = n.amount;
                                    totals.cash += n.amount;
                                    break;
                                case 2://wechat
                                    wechat = n.amount;
                                    totals.wechat += n.amount;
                                    break;
                                case 3://alipay
                                    alipay = n.amount;
                                    totals.alipay += n.amount;
                                    break;
                                case 4://card
                                    card = n.amount;
                                    totals.card += n.amount;
                                    break;
                                case 5://manager discount
                                    discount = n.amount;
                                    totals.discount += n.amount;
                                    break;

                                case 7:
                                    credit = n.amount;
                                    totals.credit += n.amount;
                                    break;
                            }
                        });

                        console.log(cash);
                        if (typeof existing === 'undefined') {
                            orders.push({
                                customer: o.customer.name,
                                days_visited: 1,
                                bills: o.total,
                                cash: cash,
                                alipay: alipay,
                                wechat: wechat,
                                discount: discount,
                                card: card,
                                credit:credit,
                                tab: 0,
                                total_sales: o.total,
                                net_sales: o.total - discount - credit,
                                first_created_at: o.first_created_at
                            });

                        } else {
                            // get day
                            if (self.get_day(existing.first_created_at) !== self.get_day(o.first_created_at)) {
                                existing.days_visited++;
                            }
                            existing.first_created_at = o.first_created_at;
                            existing.cash += cash;
                            existing.card += card;
                            existing.wechat += wechat;
                            existing.alipay += alipay;
                            existing.discount += discount;
                            existing.credit += credit;
                            existing.total_sales += o.total;
                            existing.bills += o.total;
                            existing.net_sales -= discount;
                        }

                        totals.sales += o.total;
                        totals.net_sales += o.total - discount;
                    });

                    tabs.forEach(function (tt, nn) {
                        let existing = orders.find(n => n.customer === tt.customer.name);
                        console.log(existing);
                        if (typeof existing === 'undefined') {
                            orders.push({
                                customer: tt.customer.name,
                                days_visited: 1,
                                bills: 0,
                                cash: 0,
                                alipay: 0,
                                wechat: 0,
                                discount: 0,
                                card: 0,
                                tab: tt.price,
                                total_sales: 0,
                                net_sales: 0
                            });
                        } else {
                            existing.tab += tt.price;
                            // existing.tab += tt.price;
                        }
                        totals.tab += tt.price;
                        // totals.net_sales -= tt.price;
                    });
                    orders.push({
                        customer: '',
                        days_visited: 'Totals',
                        bills: totals.sales,
                        cash: totals.cash,
                        alipay: totals.alipay,
                        wechat: totals.wechat,
                        discount: totals.discount,
                        card: totals.card,
                        tab: totals.tab,
                        total_sales: totals.sales,
                        net_sales: totals.net_sales
                    });
                    tab.orders = orders;
                    this.$forceUpdate();
                });
            },
            build_outstanding_tabs(response, tab) {
                let orders = [];
                let self = this;
                let total = 0;
                response.data.forEach(function (order, i) {
                    let existing = orders.find(o => o.customer === order.customer.name);
                    if (typeof existing === 'undefined') {
                        orders.push({
                            customer: order.customer.name,
                            date: self.formatDateDownload(order.created_at),
                            value: order.price
                        })
                    } else {
                        existing.value += order.price;
                    }
                    total += order.price;
                });
                orders.push({
                    customer: 'Totals',
                    date: '',
                    value: total
                });
                tab.orders = orders;
                this.credits = [];
                console.log('load_credits');
                this.$hget(
                    this.$http.defaults.baseURL + '/admin/credit/?credit=1').then((response) => {
                        console.log(response);
                        if(typeof response.data !== 'undefined')
                        {
                            this.credits = response.data.results;
                        }
                    });

                this.$forceUpdate();

            },
            build_rolling_monthly(response, tab) {
                /**
                 * First format existing date
                 * @type {Date}
                 * TODO: Change from orderlines to order, pull tabs seberatly add onto it.
                 */
                tab.orders = [];
                let self = this;
                response.data.forEach(function (order, i) {
                    order.search_date = self.formatSearchDate(order.created_at)
                });
                // load tabs
                console.log("TAB ITEMS");
                this.load_tabs().then(tabs => {
                    // You might use this at some stage: const { sortBy, descending, page, rowsPerPage } = this.pagination
                    let date = new Date();
                    let start = new Date(date.getFullYear(), date.getMonth(), 1);
                    let end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    let total_sales = 0;
                    let total_discount = 0;
                    let total_tab = 0;
                    let total_net = 0;
                    console.log("TABS");
                    console.log(this.tabs);
                    tabs.forEach(function (t, y) {
                        t.search_date = self.formatSearchDate(t.first_created_at);
                    });
                    while (start <= end) {
                        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                        let mm = ((start.getMonth() + 1) >= 10) ? (start.getMonth() + 1) : '0' + (start.getMonth() + 1);
                        let dd = ((start.getDate()) >= 10) ? (start.getDate()) : '0' + (start.getDate());
                        let yyyy = start.getFullYear();
                        let date = dd + "/" + mm + "/" + yyyy; //yyyy-mm-dd
                        let orders = response.data.filter(o => o.search_date === date);
                        let tabs_filtered = tabs.filter(o => o.search_date === date);
                        let order = {
                            date: dd,
                            day: days[start.getDay()],
                            total_sales: 0,
                            discount: 0,
                            tabs: 0,
                            credit:0,
                            net_sales: 0
                        };
                        orders.forEach(function (o, n) {
                            order.total_sales += o.total;
                            let discount = o.payment_types.find(o => o.type === 5);
                            let credit = o.payment_types.find(o => o.type === 7);
                            if (typeof discount !== 'undefined') {
                                order.discount += discount.amount;
                            }

                            if (typeof credit !== 'undefined') {
                                order.credit += credit.amount;
                            }
                        });
                        tabs_filtered.forEach(function (t, y) {
                            order.tabs += t.price;
                            order.total_sales += t.price;
                        });

                        order.net_sales = order.total_sales - (order.discount + order.tabs + order.credit);
                        total_sales += order.total_sales;
                        total_discount += order.discount;
                        total_tab += order.tabs;
                        total_net += order.net_sales;
                        tab.orders.push(order);
                        start = new Date(start.setDate(start.getDate() + 1)); //date increase by 1
                    }
                    tab.orders.push({
                        date: '',
                        day: 'Cumulative Month',
                        total_sales: total_sales,
                        discount: total_discount,
                        tabs: total_tab,
                        net_sales: total_net
                    });
                    this.$forceUpdate();
                    console.log(response);
                    console.log('building rolling month');
                });

            },
            load_orders(page_no) {
                let offset = (page_no - 1) * this.itemsPerPage;
                let limit = this.itemsPerPage;

                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/orders/?limit=' + limit + '&offset=' + offset + this.search_url).then((response) => {
                    this.orders = response.data;
                    this.load_tabs();
                    this.notification = false;
                    this.notification_message = '';
                    this.totalItems = (response.data.count / this.itemsPerPage);
                    let dl_data = [];
                    let ss = this;
                    this.orders.forEach(function (o, i) {
                        dl_data.push({
                            id: o.id,
                            customer: o.customer.name,
                            date: ss.formatDateDownload(o.first_created_at),
                            time: ss.formatTimeDownload(o.first_created_at),
                            total: o.total

                        })
                    });

                    this.download_data = dl_data;

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            load_tabs() {
                // start date
                return this.$http.get(
                    this.$http.defaults.baseURL + '/admin/order-lines/?start_date='+this.filter_month+'&state=2').then(response => response.data);
            },
            editItem(item) {
                this.editedIndex = this.orders.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.orders.indexOf(item);
                if (confirm('Are you sure you want to delete this item?')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/orders/' + item.id + '/').then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.orders.splice(index, 1);

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }
                if (this.editedIndex > -1) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/orders/' + this.editedItem.id + '/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        Object.assign(this.orders[this.editedIndex], this.editedItem)
                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });


                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/orders/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        this.orders.push(response.data);
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            filter_results(search) {

                if (!search.start_date) {
                    this.notification = true;
                    this.notification_type = 'red darken-1';
                    this.notification_message = 'You must enter a start date';
                    return false;
                }
                if (!search.end_date) {
                    this.notification = true;
                    this.notification_type = 'red darken-1';
                    this.notification_message = 'You must enter an end date';
                    return false;
                }


                let tab = this.tab_data[this.tab];
                const start_date = search.start_date + ' 10:30:00';
                const end_date = search.end_date + ' 10:30:00';
                const states='2,3'
                let start_filter_name = 'start_date';
                let end_filter_name = 'end_date';
                if(tab.id === 5) {
                  start_filter_name = 'def_start_created_at';
                  end_filter_name = 'def_end_created_at';
                }
                let filter = `&${start_filter_name}=${start_date}&${end_filter_name}=${end_date}&states=${states}`;
                if (search.customer && search.customer !== '') {
                    filter += '&customer=' + search.customer;
                }
                tab.filter = filter;
                this.load_filter_orders(tab);

                return false;
            },
            formatDateDownload(d) {
                return moment(String(d)).format('DD/MM/YYYY')
            },
            formatSearchDate(d)
            {
                let f_date = new Date(moment(String(d)));
                f_date.setHours(f_date.getHours() - 10);
                console.log(new Date(moment(String(d))));
                console.log(f_date);
                console.log(moment(String(f_date.toISOString())).format('DD/MM/YYYY'));
                return moment(String(f_date.toISOString())).format('DD/MM/YYYY')

            },
            formatTimeDownload(d) {
                return moment(String(d)).format('H:mm')
            },
            get_day(date) {
                return moment(String(date)).format('d')
            }
        },
    }
</script>
